import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Input from "../../components/Input";
import { useLocation, useNavigate } from "react-router-dom";
import { useForgotPasswordMutation } from "../../apis/loginApis";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";

type Props = {};

const ChangePassword = (props: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const location = useLocation();
  const [email, setEmail] = useState("");

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const emailParam = queryParams.get("email");
    if (emailParam) {
      setEmail(emailParam);
    }
  }, [location.search]);
  const { mutate, isPending } = useForgotPasswordMutation();
  const submitPasswordData = async (data: any) => {
    if (data?.newPassword !== data?.confirmPassword) {
      toast.error("Password and confirm password will be same");
      return;
    }
    mutate(
      { ...data, email, type: "outlet" },
      {
        onSuccess: (data: any) => {
          toast.success(data?.message);
          setTimeout(() => {
            navigate("/");
          }, 1000);
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      },
    );
  };

  return (
    // <div className="flex items-center justify-center ">
    //   <div className="w-full">
    //     <div className="flex justify-center items-center">
    //       <div className="space-y-4">
    //         <div>
    //           <h2 className="text-3xl font-medium text-center">
    //             {t("Change Password")}
    //           </h2>
    //           <p className="text-[#000000]/70">
    //             {t("Please Set Strong Password")} {email}
    //           </p>
    //         </div>
    //         <div>
    //           <form
    //             onSubmit={handleSubmit(submitPasswordData)}
    //             className="space-y-4"
    //           >
    //             <div className="space-y-4">
    //               <Input
    //                 name="newPassword"
    //                 type="password"
    //                 title="Password"
    //                 placeholder="Enter Your Password"
    //                 register={register}
    //                 error={errors.newPassword}
    //                 validation={{
    //                   required: "Password is required",
    //                   pattern: {
    //                     value:
    //                       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    //                     message:
    //                       "Password must be at least 8 characters \n and include uppercase, lowercase, \n number, and special character",
    //                   },
    //                 }}
    //               />
    //               <Input
    //                 name="confirmPassword"
    //                 type="password"
    //                 title="Confirm Password"
    //                 placeholder="Enter Your Confirm Password"
    //                 register={register}
    //                 error={errors.confirmPassword}
    //                 validation={{
    //                   required: "Confirm Password is required",
    //                   pattern: {
    //                     value:
    //                       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    //                     message:
    //                       "Confirm password must be at least 8 characters \n and include uppercase, lowercase, \n number, and special character",
    //                   },
    //                 }}
    //               />
    //             </div>
    //             <button
    //               type="submit"
    //               disabled={isPending}
    //               className={`w-full flex justify-center items-center gap-2 font-semibold py-3 rounded-full transition
    // ${
    //   isPending
    //     ? "bg-gray-800 cursor-not-allowed text-[#ffffff]"
    //     : "bg-[#FBD037] hover:bg-yellow-400 text-[#000000]"
    // }
    // `}
    //             >
    //               {isPending ? (
    //                 <>
    //                   <svg
    //                     className="animate-spin h-5 w-5 text-white"
    //                     xmlns="http://www.w3.org/2000/svg"
    //                     fill="none"
    //                     viewBox="0 0 24 24"
    //                   >
    //                     <circle
    //                       className="opacity-25"
    //                       cx="12"
    //                       cy="12"
    //                       r="10"
    //                       stroke="currentColor"
    //                       strokeWidth="4"
    //                     />
    //                     <path
    //                       className="opacity-75"
    //                       fill="currentColor"
    //                       d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z"
    //                     />
    //                   </svg>
    //                   Reseting Password...
    //                 </>
    //               ) : (
    //                 "Change Password"
    //               )}
    //             </button>
    //           </form>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <div className=" w-full">
    //     <img src="/img/login-screen.svg" alt="" className="w-fit" />
    //   </div>
    // </div>

    <div className="flex items-center justify-center h-screen  bg-gradient-to-l from-[#FFE783] to-[#E4E5E7]">
      <div className=" w-[40%] relative h-full flex justify-center items-center ">
        <div className="flex flex-col items-center gap-6">
          {/* <div className="flex justify-center">
                <LanguagePicker />
              </div> */}
          <div className="space-y-6 p-6   2xl:w-[28rem] lg:w-[26rem] w-full">
            <div className="flex justify-start">
              <img
                src="/img/logo-tracktech-black.svg"
                alt="Logo"
                className="2xl:w-60 w-52"
              />
            </div>

            <div className="text-left">
              <h2 className="2xl:text-3xl text-2xl font-medium ">
                {t("Change Password")}
              </h2>
              <p className="text-[#000000]/70 2xl:text-base text-sm">
                {t("Please Set Strong Password")} {email}
              </p>
            </div>
            <form
              onSubmit={handleSubmit(submitPasswordData)}
              className="space-y-4"
            >
              <div className="space-y-4">
                <Input
                  name="newPassword"
                  type="password"
                  title="Password"
                  placeholder="Enter Your Password"
                  inputClassName="rounded-lg w-full py-2.5 px-4 text-base text-[#1E1E1E] border border-[#D8D8D8]"
                  register={register}
                  error={errors.newPassword}
                  validation={{
                    required: "Password is required",
                    pattern: {
                      value:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                      message:
                        "Password must be at least 8 characters \n and include uppercase, lowercase, \n number, and special character",
                    },
                  }}
                />
                <Input
                  name="confirmPassword"
                  type="password"
                  title="Confirm Password"
                  placeholder="Enter Your Confirm Password"
                  inputClassName="rounded-lg w-full py-2.5 px-4 text-base text-[#1E1E1E] border border-[#D8D8D8]"
                  register={register}
                  error={errors.confirmPassword}
                  validation={{
                    required: "Confirm Password is required",
                    pattern: {
                      value:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                      message:
                        "Confirm password must be at least 8 characters \n and include uppercase, lowercase, \n number, and special character",
                    },
                  }}
                />
              </div>
              <button
                type="submit"
                disabled={isPending} // disable when loading
                className={`w-full flex justify-center items-center gap-2 font-semibold py-3 rounded-full transition
    ${
      isPending
        ? "bg-gray-800 cursor-not-allowed text-[#ffffff]"
        : "bg-[#FBD037] hover:bg-yellow-400 text-[#000000]"
    }
    `}
              >
                {isPending ? (
                  <>
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z"
                      />
                    </svg>
                    Reseting Password...
                  </>
                ) : (
                  "Change Password"
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="w-[60%] h-full flex justify-end relative bg-cover overflow-hidden">
        <img
          src="\img\dashboard-icons\outlet.png"
          className="w-10/12 "
          alt="login-screen"
        />
      </div>
    </div>
  );
};

export default ChangePassword;
